// Map zoom levels - centralized to ensure consistency
export const MAP_ZOOM_LEVELS = {
  INITIAL_MOBILE: 0.3,
  INITIAL_DESKTOP: 0.5,
  TEXT_VISIBLE_THRESHOLD_MOBILE: 0.8,
  TEXT_VISIBLE_THRESHOLD_DESKTOP: 1.5,
  STREET_LEVEL: 15,
} as const;
